import React from 'react';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import {
  getIngIdStockNumber,
  getIngNameByIngId,
  getIngredientTypeName,
  isNullOrUndefined,
  padZeros,
} from 'utils/Global';

const ProteinVariantStdIngCard = (props) => {
  const { ingredient } = props;

  return (
    <div id='proteinvariantstdingcard-wrapper' className="w-[96%] mt-[0.5rem] border border-solid content-center justify-items-center border-[#888888] rounded-[4px]">
      <div id={`proteinvariantstdingcard-container-${ingredient.id}`} className="w-[95%] mt-[2%] mb-[1%] flex flex-row justify-between">
        <div id={`proteinvariantstdingcard-icon-container-${ingredient.id}`} className="w-[9.7%] h-[100%]">
          <RMSvgIcon
            id='proteinvariantstdingcard-svg-ingtubes-icon'
            name="IngredientTubes"
            fill="#414042"
            height="2.25rem"
            width="2.25rem"
          />
        </div>
        <div id={`proteinvariantstdingcard-content-${ingredient.id}`} className="w-[65%] flex flex-col">
          <div id={`proteinvariantstdingcard-title-${ingredient.id}`} className="text-[1.077rem] text-[#1B1B1B] font-bold">
            {ingredient.ingredientStock
              ? getIngNameByIngId(ingredient.ingredientStock.ingredientId)
              : null}
          </div>
          <div id={`proteinvariantstdingcard-type-${ingredient.id}`} className="text-[#313131] text-[0.923rem] font-[500]">
            {isNullOrUndefined(ingredient)
              ? null
              : `${getIngredientTypeName(ingredient.ingredientIngredientTypeId)}`}
          </div>
          <div id={`proteinvariantstdingcard-concentration-${ingredient.id}`} className="text-[#5D5D5D] text-[0.923rem]">
            Conc.{' '}
            {isNullOrUndefined(ingredient.concentration)
              ? 0
              : ingredient.concentration.toFixed(2)}{' '}
            {ingredient.ph ? `pH ${ingredient.ph}` : ''}
          </div>

          {ingredient.ingredientStock.isBuffer ? (
            <>
              <div id={`proteinvariantstdingcard-stockbuffer-${ingredient.id}`} className="text-[#5D5D5D] text-[0.923rem]">
                Stock {ingredient.ingredientStock.stockConcentration}{' '}
                {ingredient.ingredientStock.concentrationUnits}, pH{' '}
                {ingredient.ingredientStock.stockPh}{' '}
                {getIngIdStockNumber(
                  ingredient.ingredientStock.ingredientId,
                  ingredient.ingredientStock.stockNumber,
                )}
              </div>
              {ingredient.highPhingredientStock && (
                <div id={`proteinvariantstdingcard-stockhighph-${ingredient.id}`} className="text-[#5D5D5D] text-[0.923rem]">
                  Stock{' '}
                  {!isNullOrUndefined(ingredient.highPhingredientStock) &&
                    ingredient.highPhingredientStock.stockConcentration}{' '}
                  {!isNullOrUndefined(ingredient.highPhingredientStock) &&
                    ingredient.highPhingredientStock.concentrationUnits}
                  , pH {ingredient.highPhingredientStock?.stockPh}{' '}
                  {!isNullOrUndefined(ingredient.highPhingredientStock) &&
                    getIngIdStockNumber(
                      ingredient.highPhingredientStock.ingredientId,
                      ingredient.highPhingredientStock.stockNumber,
                    )}
                </div>
              )}
            </>
          ) : (
            <div id={`proteinvariantstdingcard-stocknonbuffer-${ingredient.id}`} className="text-[#5D5D5D] text-[0.923rem]">
              Stock {padZeros(ingredient.ingredientStock.stockNumber, 3)}{' '}
              {ingredient.ingredientStock.stockConcentration}{' '}
              {ingredient.ingredientStock.concentrationUnits}{' '}
              {getIngIdStockNumber(
                ingredient.ingredientStock.ingredientId,
                ingredient.ingredientStock.stockNumber,
              )}
            </div>
          )}
        </div>
        <div id={`proteinvariantstdingcard-actions-${ingredient.id}`} className="w-[19.4%] flex flex-row justify-between"></div>
      </div>
    </div>
  );
};

export default ProteinVariantStdIngCard;
